import { useEffect, useState } from "react";
import CartNav from "../Cart/Cart";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../Api/Api";
import axios from "axios";
import Cookie from "cookie-universal";

export default function MyOrders(){
  const[data,setData]=useState([]);
  //navigate
  const Navigate=useNavigate();
  //cookie
  const cookie=Cookie();

    // get cart data
      useEffect(() => {
        try{   axios.get(`${baseURL}/cart`, {
      headers: {
        Authorization: "Bearer " + cookie.get("e-commerce"),
      },
    })
    .then((data) =>{setData(data.data);
    })
  }
    catch(err){
     console.log(err)
    }
  }, []);
  //mapping
  const dataShow=data?.map((item,key)=>{
    const totalPrice = item.products.reduce((acc, pro) => {
      const price = pro.product
        ? Number(pro.product.discount!=="0" ? pro.product.discount : pro.product.price)
        : 0;
      return acc + price * (pro.count || 0);
    }, 0);
    return(<div key={key} className="ps-2">
    <div className="d-flex justify-content-start" 
    style={{color:item.status=='Success'?'#0edd7d':item.status=='accepted'?'var(--primaryColor)'
    :item.status=='rejected'?'red':'black'}}><h6>{item.status}</h6></div>
    <div   className="d-flex justify-content-start gap-2 align-items-center  ">
      <div style={{width:'85%'}}>
   {item?.products.map((pro,index)=>
   
 <div key={index} className='details-order-div d-flex justify-content-between align-items-center '
 style={{paddingBlock:'5px'}}>
       <div><h6>{pro.product.title}</h6></div>
       <div><h6>price: ${pro.product.discount!== "0"?pro.product.discount:pro.product.price}</h6></div>
       <div><h6>count: {pro.count}</h6></div>
 </div>
 

)}
</div>
<h6 style={{color:'#13bf13'}}>${totalPrice}</h6>
 </div>
 <div className="d-flex justify-content-between gap-2">
  <p>{item.result}</p>
  <div className="d-flex gap-2" style={{minWidth:'45%'}} >
    <p style={{minWidth:'35%'}}>{item.created_at.split('T')[0]}</p>
  <p style={{minWidth:'35%'}}>{item.created_at.split('T')[1].slice(0,8)}</p>
  </div>
 </div>
 </div>)
}).reverse();
    
    return(
      <div className='web-back-ground'>
        <CartNav title="My orders" description="orders list" show={true} showBtn={false}  data={dataShow} handleClose={()=>Navigate('/' , {replace:true})}/>
      </div>
    );
}